import axios from "axios";

// export const api = "https://api-dev.nirantara.solutions";
// const API_BASE_URL = "https://api-dev.nirantara.solutions";

// export const api = "https://xbdq06nv-8081.inc1.devtunnels.ms";
// const API_BASE_URL = "https://xbdq06nv-8081.inc1.devtunnels.ms";

export const api = "https://api.nirantara.ai";
const API_BASE_URL = "https://api.nirantara.ai";

// export const api = "http://localhost:8081";
// const API_BASE_URL = "http://localhost:8081";

// export const api = "https://uat-api.nirantara.ai";
// const API_BASE_URL = "https://uat-api.nirantara.ai";

// Create an Axios instance with common configuration
const axiosInstance = axios.create({
  baseURL: API_BASE_URL,
  timeout: 600000,
  headers: {
    "Content-Type": "application/json",
  },
});

// Update the Authorization header before each request
axiosInstance.interceptors.request.use((config) => {
  const token = sessionStorage.getItem("token")
    ? sessionStorage.getItem("token")
    : ``;
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Centralized error handling
const handleRequestError = (error) => {
  let err = {
    errorType: "Unknown Error",
    message: error.message,
    response: "Failure",
  };

  if (error.response) {
    // Handle HTTP errors (e.g., 404, 500)
    if (error.response.status === 401) {
      localStorage.removeItem("token");
      localStorage.removeItem("refreshToken");
      localStorage.removeItem("companyId");
      localStorage.removeItem("user");
      localStorage.removeItem("module");
      window.location.replace("/login");
    }
    err = {
      errorType: "HTTP Error",
      status: error.response.status,
      message: error.response.data,
      response: "Failure",
    };
  } else if (error.request) {
    // Handle network issues (e.g., no internet connection)
    err = {
      errorType: "Network Error",
      message: error.message,
      response: "Failure",
    };
  }
  return err;
};

// GET request function
export const get = async (url, params = {}) => {
  try {
    const response = await axiosInstance.get(url, params);
    return { data: response.data, response: "Success" };
  } catch (error) {
    handleRequestError(error);
    throw error;
  }
};

// POST request function
export const post = async (url, data = {}) => {
  try {
    const response = await axiosInstance.post(url, data);
    return { data: response.data, response: "Success" };
  } catch (error) {
    handleRequestError(error);
    throw error;
  }
};

export const postFile = async (url, file) => {
  try {
    const formData = new FormData();
    formData.append("files", file);

    const response = await axiosInstance.post(url, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });

    return { data: response.data, response: "Success" };
  } catch (error) {
    handleRequestError(error);
    throw error;
  }
};

// PUT request function
export const put = async (url, params = {}) => {
  try {
    const response = await axiosInstance.put(url, params);
    return { data: response.data, response: "Success" };
  } catch (error) {
    handleRequestError(error);
    throw error;
  }
};

// PATCH request function
export const patch = async (url, data = {}) => {
  try {
    const response = await axiosInstance.patch(url, data);
    return { data: response.data, response: "Success" };
  } catch (error) {
    handleRequestError(error);
    throw error;
  }
};

// DELETE request function
export const del = async (url, config = {}) => {
  try {
    const response = await axiosInstance.delete(url, config);
    return { data: response.data, response: "Success" };
  } catch (error) {
    handleRequestError(error);
    throw error;
  }
};

// POST with files
export const postFiles = async (url, data, method = "POST") => {
  try {
    const response = await fetch(`${API_BASE_URL}${url}`, {
      method: method,
      headers: {
        Authorization: `Bearer ${sessionStorage.getItem("token")}`,
      },
      body: data,
    });

    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }

    const responseData = await response.json();
    return { data: responseData, response: "Success" };
  } catch (error) {
    handleRequestError(error);
    throw error;
  }
};
